<script setup lang="ts">
import { ref, onMounted } from 'vue'

const sprite = ref('')

onMounted(async () => {
  const res = await fetch('/portal/assets/svg/sprite.svg')
  sprite.value = await res.text()
})
</script>

<template>
  <div
    v-html="sprite"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
</template>
